import { Box, CircularProgress, Grid } from "@mui/material";
import React, { useEffect } from "react";
import { observer, useLocalObservable } from "mobx-react";
import { UserModel } from "../../domains/models/UserModel";
import { useRootStore } from "store/StoreContextProvider";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import HomePageStore from "pages/HomePage/store/HomePageStore";
import useSnackbarMessage from "shared/snackbar";
import { EmployeeModel } from "domains/models/EmployeeModel";
import { toJS } from "mobx";
import NoDataImage from '../../assets/image/no-data-icon.svg';

const LoginByEmailPage = () => {
  const [isLoading, setLoading] = React.useState(false);
  const [alert, setAlert] = React.useState({
    open: false,
    severity: "success",
    message: "",
    title: "",
  });

  const pageStore = useLocalObservable(() => new HomePageStore());
  const { loginStore } = useRootStore();
  const snackbar = useSnackbarMessage();

  const navigate = useNavigate();
  const location = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();

  const email = `${searchParams.get("email")}`;
  const fromEmail = `${searchParams.get("from")}`;
  const messageId = `${searchParams.get("messageId")}`;
  const conversationId = `${searchParams.get("conversationId")}`;

  const emailChecked = searchParams.get("emailchecked") === "true";
  const teamsChecked = searchParams.get("teamschecked") === "true";
  const MASTER_PASS = "jeisyscross123!";

  const signin = async (email: string, password: string) => {
    try {
      const response = await loginStore.onLoginByEmail(email, password);

      if (response.user) {
        const user: UserModel = {
          ...response.user,
        };
        loginStore.setCurrentUser(
          user,
          response.accessToken as string,
          response.refreshToken as string
        );

        await fetchAppraiseeByEmail();
        //await fetchTargetsByDeptCode();
        extractOneEmployeeFromList();
      }
    } catch (error) {
      console.log(error);
      const response = error as {
        code: number;
      };
      if (response.code !== 200) {
        setAlert({
          open: true,
          severity: "error",
          title: "로그인에러",
          message: "사용자 아이디와 바밀번호를 확인하세요.",
        });
      }
    }
  };

  const fetchAppraiseeByEmail = async () => {
    const res = await pageStore.fetchTargetByEmail(fromEmail);

    if (res?.expired) {
      loginStore.onLogout();
    }    
  }

  const fetchTargetsByDeptCode = async () => {
    try {
      console.log(loginStore.currentUser);
      if (
        loginStore.currentUser?.userData.downwardsList &&
        loginStore.currentUser?.userData.peerList
      ) {
        pageStore.setTabValue("");
      } else if (loginStore.currentUser?.userData.downwardsList) {
        pageStore.setTabValue("downwards");
      } else if (loginStore.currentUser?.userData.peerList) {
        pageStore.setTabValue("peer");
      }

      pageStore.setTabValue("");
      if (loginStore.currentUser) {
        const res = await pageStore.fetchTargetsByDeptCode(
          loginStore.currentUser
        );
        if (res?.expired) {
          loginStore.onLogout();
          return;
        }
      } else {
        loginStore.onLogout();
        return;
      }
    } catch (err: any) {
      if (err.response.data.header.code === 1) {
        snackbar.error(`어드민에서 동료와 부하직원 리스트를 설정해주세요: ${fromEmail}`);
      } else {
        snackbar.error(err.message);
      }
    }
  };

  const extractOneEmployeeFromList = () => {
    for(const employee of pageStore.employeeList) {
      if (employee.email === fromEmail) {
        const nextUrl = "/plugin/mails" + location.search;
        navigate(nextUrl, { state: { employee: toJS(employee) } });
        return;
      }
    }

    const nextUrl = "/plugin/mails" + location.search;
    navigate(nextUrl, { state: { employee: ""} });

    return;
  };

  useEffect(() => {
    if (!fromEmail.includes('jeisys.com')) {
      snackbar.error(`사내이메일에 대해서만 평가 가능합니다: ${fromEmail}`);
    }

    async function fetch_and_extract() {
      await fetchAppraiseeByEmail();
      //await fetchTargetsByDeptCode();
      extractOneEmployeeFromList();
    }

    if (!loginStore.currentUser && email) {
      signin(email, MASTER_PASS);
    } else {
      fetch_and_extract();
    }
  }, []);

  /************************************************************************
   * Render
   ************************************************************************/

  return (
    <Box
      sx={{ width: "100%" }}
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="70vh"
    >
      <Grid container justifyContent={"center"} style={{ marginTop: "150px" }}>
        <CircularProgress />
        {/* {isLoading && <CircularProgress />}
        {!isLoading && <img src={NoDataImage} style={{ width: 100, height:100, opacity: 0.5 }} />} */}
      </Grid>
    </Box>
  );
};

export default observer(LoginByEmailPage);
